import { Component, OnInit, NgZone, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatExpansionPanel } from '@angular/material';
import { CategoriesService } from '../_services/categories.service'
import { AngularFirestore } from 'angularfire2/firestore';




@Component({
  selector: 'app-categories-menu',
  templateUrl: './categories-menu.component.html',
  styleUrls: ['./categories-menu.component.css']
})
export class CategoriesMenuComponent implements OnInit {
  categories = [];
  collapse = false;
  isLoading = true;
  isMobile = false;
  @ViewChild(MatExpansionPanel) expansionPanel: MatExpansionPanel;
  constructor( private zone: NgZone, private afs: AngularFirestore, private router: Router, private categoriesService: CategoriesService) {
    this.afs.collection('categories').ref.where('parent', '==', false).get().then((category => {
      category.forEach(categoryname => {
        this.categories.push(categoryname.data());
      });
      this.isLoading = false;

    }));


    this.isMobile = window.matchMedia('(max-width: 1024px)').matches;

  }

  navigate(name) {
    this.zone.run(() => this.router.navigate(['/category/' + name]))
  }

  ngOnInit() {
    if (this.isMobile) {
      this.expansionPanel.open();
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/categories-menu/categories-menu.component.ts